import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const BEHOLDER_URL = getBaseUrl('/beholder/');

export async function getIndexes() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}memory/indexes`);
}

// Saúde por-item (monitores/automações/estratégias): { monitors:{id:{status,reasons}}, ... }
export async function getItemsHealth() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}items-health`);
}

// Classifica cada condição contra o cache atual: [{ expr, color, met }].
// color: 'red' (não existe) | 'yellow' (parado) | 'green' (ok) | 'blue' (atendida)
export async function diagnoseConditions(symbol, expressions) {
    if (!expressions || expressions.length === 0) return [];
    return await appRequest.doPostRequest(`${BEHOLDER_URL}diagnose-conditions`, { symbol, expressions });
}

export async function ensureSystemTicker() {
    return await appRequest.doPostRequest(`${BEHOLDER_URL}ensureSystemTicker`, {});
}

export async function getMemoryIndex(symbol, index, interval) {
    const path = interval ? `${symbol}/${index}/${interval}` : `${symbol}/${index}`;
    return await appRequest.doGetRequest(`${BEHOLDER_URL}memory/${path}`);
}

export async function getAnalysisIndexes() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}analysis`);
}

export async function getMemory() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}memory`);
}

export async function getAgenda() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}agenda`);
}

export async function getBrain() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}brain`);
}

export async function getCircuitBreaker() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}circuitBreaker`);
}

export async function resetCircuitBreaker() {
    return await appRequest.doDeleteRequest(`${BEHOLDER_URL}circuitBreaker`);
}

export async function getScannerResults() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}scannerResults`);
}

export async function getScanRecommendations() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}scanRecommendations`);
}

export async function getCockpit(symbols) {
    if (!symbols || symbols.length === 0) return {};
    const param = encodeURIComponent(symbols.join(','));
    return await appRequest.doGetRequest(`${BEHOLDER_URL}cockpit?symbols=${param}`);
}

export async function getSystemHealth() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}health`);
}

export async function getOperationalHealth() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}operational`);
}

export async function getFullStatus() {
    return await appRequest.doGetRequest(`${BEHOLDER_URL}full-status`);
}


export async function resetCache() {
    return await appRequest.doPostRequest(`${BEHOLDER_URL}cache/reset`, {});
}
